import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import '../assets/styles/JobFilters.css'; // Make sure to import the CSS file

const JobFilter = ({ onFilter }) => {
    const [location, setLocation] = useState('');
    const [category, setCategory] = useState('');
    const [experience, setExperience] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onFilter({ location, category, experience });
    };

    return (
        <Form className="job-filter" onSubmit={handleSubmit}>
            <Form.Group controlId="location">
                <Form.Label>Location</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                />
            </Form.Group>
            <Form.Group controlId="category">
                <Form.Label>Job Category</Form.Label>
                <Form.Control
                    as="select"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                >
                    <option value="">Select category</option>
                    <option value="Daily Labour">Daily Labour</option>
                    <option value="Skilled Workers">Skilled Workers</option>
                    <option value="Construction Workers">Construction Workers</option>
                    <option value="Manufacturing Workers">Manufacturing Workers</option>
                    <option value="Logistics Workers">Logistics Workers</option>
                    <option value="Customer Support">Customer Support</option>
                    <option value="Administrative Staff">Administrative Staff</option>
                    <option value="Sales and Marketing">Sales and Marketing</option>
                 
                </Form.Control>
            </Form.Group>
            <Form.Group controlId="experience">
                <Form.Label>Experience</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter experience (e.g., 2+ years)"
                    value={experience}
                    onChange={(e) => setExperience(e.target.value)}
                />
            </Form.Group>
            <Button variant="primary" type="submit">
                Apply Filters
            </Button>
        </Form>
    );
};

export default JobFilter;
